import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageDialogComponent } from '../message/message-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ConfirmDialog } from '../confirmation/confirm.dialog';
import { SettingsService } from '../services/settings.service';
import { AuthService } from '../services/auth.service';
import * as moment from 'moment';
import { AppConfig } from "../model/config";
import { HeromaStates, Roles } from '../common/enums';
import { LogHelperComponent } from '../user-import-logs/logHelper.component';
import { UserImportLog } from '../model/userImportLog';
import { Subscription } from 'rxjs';
import { SignalRService } from '../services/signalr.service';
import { LoggerService } from '../services/logger.service';
import { MessageService } from '../services/message.service';
import { LiveFlightService } from '../services/liveFlight.service';
import { ActivityActorService } from '../services/activityActor.service';
import { StateMachineEventEnum } from '../model/stateMachineEvent';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit, OnDestroy, AfterViewInit {

  private lastImportSubscription: Subscription;
  private unhandledLogsSubscription: Subscription;
  private showNavbarSubscription: Subscription;
  private bfsCreatedSubscription: Subscription;

  private timerId: any;
  private confirmModalRef: MatDialogRef<ConfirmDialog>;
  private messageModalRef: MatDialogRef<MessageDialogComponent>;
  private lastImportLog: UserImportLog = undefined;
  private newTransferCount: number;

  public unhandledLogs: number = 0;
  public isPlanner: boolean;
  public menustatus: boolean = false;
  public currentTime: string;
  public currentDate: string;
  public lastImportToolTipText: string;
  public currentHeromaState: string = HeromaStates.unknown;
  public showNavbar: boolean = true;

  @ViewChild('mailButton', { read: ElementRef }) mailButton: ElementRef;
  version: string;
  environmemt: string;
  public errorMessage: string = '';

  @ViewChild('busHonk', { static: true })
  busHonkRef: ElementRef;


  public get liveFlightStatusColor() {
    return this.liveFlightService.LiveFlightStatusColor;
  }

  public get liveFlightStatusText() {
    return this.liveFlightService.LiveFlightStatusText;
  }

  public get liveFlightStatusIcon() {
    return this.liveFlightService.LiveFlightStatusIcon;
  }

  public get hubConnectionStatusText() {
    return this.signalRservice.hubConnectionStatusText;
  }

  public get hubConnectionStatusIcon() {
    return this.signalRservice.hubConnectionStatusIcon;
  }

  constructor(
    private signalRservice: SignalRService,
    private liveFlightService: LiveFlightService,
    private readonly settings: SettingsService,
    private readonly dialog: MatDialog,
    private readonly auth: AuthService,
    private readonly configuration: AppConfig,
    private readonly logHelperComponent: LogHelperComponent,
    private readonly errorHandler: LoggerService,
    private readonly authService: AuthService,
    private readonly messageService: MessageService,
    private readonly activityActorService: ActivityActorService,
    private readonly router: Router) {
    this.version = this.configuration.release.version;
    this.environmemt = this.configuration.release.environment;

  }

  ngOnInit() {
    this.checkLastImportStatus();
    this.setTime();

    this.lastImportSubscription = this.logHelperComponent.lastImportLog.subscribe((log) => {
      this.lastImportLog = log;
      this.checkLastImportStatus();
    });

    this.unhandledLogsSubscription = this.logHelperComponent.unhandledLogs.subscribe((unhandledLogs) => {
      this.unhandledLogs = unhandledLogs;
    })

    this.errorHandler.ErrorEvent$.subscribe({
      next: (event: string) => {
        this.errorMessage = event;
      }
    }); 

    this.showNavbarSubscription = this.settings.toggleShowNavbar$.subscribe((showNavbar: boolean) => {
      this.showNavbar = showNavbar;
    });

    this.bfsCreatedSubscription = this.activityActorService.bfsTransferCreated$.subscribe(() => {
      this.playSound();
    })

    this.activityActorService.updateActivity$.subscribe(
      () => {
        const activityActors = this.activityActorService.activityActors;
        const createdTransfers = activityActors.filter(x => x.IsTransfer && x.activityActor.state == StateMachineEventEnum.Create);
        this.newTransferCount = createdTransfers.length;
      });

    this.activityActorService.activityActorLoaded$.subscribe(
      () => {
        const activityActors = this.activityActorService.activityActors;
        this.newTransferCount = activityActors.filter(x => x.IsTransfer && x.activityActor.state == StateMachineEventEnum.Create).length;

      });
    this.router.routeReuseStrategy.shouldReuseRoute = () => { return false; };

  }

  ngAfterViewInit() {
    this.authService.groupsReady$.subscribe(s => {
      //Check this once at init, ngIf condition is constantly being checked and even the simplest functioncall can be expensive
      this.isPlanner = this.auth.isInRole(Roles.Planner);
    });

    this.timerId = setInterval(() => {
      this.setTime()
    }, 1000 * 10);
  }

  ngOnDestroy() {
    clearInterval(this.timerId);
    this.lastImportSubscription.unsubscribe();
    this.unhandledLogsSubscription.unsubscribe();
    this.showNavbarSubscription.unsubscribe();
    this.bfsCreatedSubscription.unsubscribe();
  }

  setTime() {
    this.currentTime = moment(new Date()).format('HH:mm');
    this.currentDate = moment(new Date()).format('dddd, MMMM Do YYYY HH:mm');
  }

  mail(event) {
    console.log("mail", this.messageModalRef);
    if (this.dialog.openDialogs.some(d => d === this.messageModalRef)) {
      this.messageModalRef.close();
      this.messageModalRef = undefined;
    }
    else {
      let buttonCoord = this.mailButton.nativeElement.getBoundingClientRect();
      this.messageModalRef = this.dialog.open(MessageDialogComponent, { width: '400px', height: '600px', disableClose: false, closeOnNavigation: false, hasBackdrop: false, position: { top: (buttonCoord.bottom - 10) + 'px', left: ((buttonCoord.left - 400) + 10) + 'px' }, panelClass: 'no-padding-dialog' });
      this.messageModalRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });
    }

  }

  login() {
    console.log("login");
  }
  public get userName() {
    var user = this.auth.getUser();
    return user != "" ? user : "Not authenticated";
  }

  logout() {
    console.log("logout");
    this.confirmModalRef = this.dialog.open(ConfirmDialog, {
      disableClose: false, width: "400px", autoFocus: false,
      closeOnNavigation: false, data:
      {
        title: "Bekräfta",
        text: "Vill du verkligen logga ut?"
      }
    });

    this.confirmModalRef.afterClosed().subscribe(result => {
      if (result) {
        this.auth.logout();
      }
    });

  }

  toggleSound() {
    this.settings.toggleSound();
  }

  isAuthenticated() {
    return true;
  }

  public showImportLogs() {
    if (!this.isPlanner) return;
    this.logHelperComponent.openImportLogDialog();
  }

  OCmenu() {
    this.menustatus = !this.menustatus;
  }

  private checkLastImportStatus() {

    if (this.lastImportLog === undefined) {
      this.currentHeromaState = HeromaStates.unknown;
      this.lastImportToolTipText = "Ingen uppdatering";
      return;
    }

    let current = moment(new Date());
    let lastImport = moment(this.lastImportLog.createdAt);

    let diffInDays = current.diff(lastImport, 'days');

    if (diffInDays > 1) {
      this.currentHeromaState = HeromaStates.error;
    }
    else {
      this.currentHeromaState = HeromaStates.ok;
    }

    this.lastImportToolTipText = this.lastImportLog.message;
  }

  reload() {
    window.location.reload();
  }

  getErrorMessage() {
    return "Fel i BKS, klicka här för refresh! Senaste felet: " + this.errorMessage;
  }

  hasTransfers() {
    let transfers = this.newTransferCount ? this.newTransferCount > 0 : false;
    return transfers;
  }

  showTransfer() {
    const hasTransfers = this.hasTransfers();

    this.router.navigateByUrl('/plan', { state: { transfer: hasTransfers } })
  }

  playSound() {
    console.log("honk - nav-bar")
    if (this.settings.sound) {
      this.busHonkRef.nativeElement.play();
    }
  }
}
